<div (click)="onImageClick.emit($event)"
    class="image-carousel has-pos-rel {{carouselParentName}}"
    [class.luxury]="isLuxury && isListingDetails"
    [class.commercial]="isCommercial">
  <div class="is-flex image-container" appRmSwiper (onSwipe)="swipeCarousel($event)" [stopPropagation]="true" [stopDefault]="false" [isEnabled]="isListingDetails">
    <div class="images is-flex flex-one has-flex-align-center has-flex-content-center" (keydown.enter)="onImageClick.emit($event)" role="tablist" tabindex="0"
      [attr.aria-label]="'gallery.aria.carousel' | translate"
      (keydown.arrowleft)="prevSlide($event)"
      (keydown.arrowright)="nextSlide($event)"
      >
      <ng-container *ngIf="!imageCount; else hasImages">
        <img src="{{placeHolderImage | staticp}}" class="active image full-width full-height" [alt]="'gallery.aria.placeholder' | translate">
      </ng-container>
      <ng-template #hasImages>
        <ng-container *ngFor="let url of visibleImages; let i = index; trackBy: trackFn">
            <img appImgIxImage appImgLoader role="tabpanel"
              class="image"
              (error)="imgErrorHandler($event)"
              [fallbackImageUrl]="placeHolderImage | staticp"
              [url]="url"
              [showHighDprImages]="showHighDprImages"
              [imageQualityPercentage]="imageQualityPercentage"
              [class.lazyload]="(i <= (currentSlideIndex + 3)) || (i > (imageCount - 2))"
              [class.lazypreload]="isSelectedCarousel || isNextCarousel"
              [class.active]="i === currentSlideIndex"
              [alt]="'gallery.aria.listingPhoto' | translate" />
        </ng-container>
      </ng-template>
    </div>
    <div class="controls full-width has-pos-abs" *ngIf="isSelectedCarousel && imageCount > 1">
      <!-- Left Control -->
      <span class="has-pos-abs prev control no-select" (click)="prevSlide($event)" role="presentation">
        <i class="material-icons">chevron_left</i>
      </span>
      <!-- Right Control -->
      <span class="has-pos-abs next control no-select" (click)="nextSlide($event)" role="presentation">
        <i class="material-icons">chevron_right</i>
      </span>
    </div>
  </div>
  <footer class="bottom has-flex-align-center has-flex-content-center is-flex">
    <div class="slide-indicator has-flex-align-center has-flex-content-center is-flex" *ngIf="imageCount > 1">
      <div class="prev control is-flex has-flex-align-center no-select" (click)="prevSlide($event)" role="presentation">
        <i class="material-icons">chevron_left</i>
      </div>
      <span class="slide-count">{{currentSlideIndex + 1}} of {{ imageCount }}</span>
      <div class="next control is-flex has-flex-align-center no-select" (click)="nextSlide($event)" role="presentation">
        <i class="material-icons">chevron_right</i>
      </div>
    </div>
    <ng-content *ngIf="imageCount && visibleImages[0] != null"></ng-content>
  </footer>
</div>
